<pbc-filter [config]="TourenFilterConfig" [filter]="touren.filter$ | async" (filterChange)="touren.filter$.next($event)"></pbc-filter>
